<template>
  <div class="candies">
    <div class="main">
      <img class="bg-img" src="./images/bg.png" alt="" />
      <img class="avatar" src="./images/btn-avatar.webp" alt="" />
      <span class="balance">我的胡蘿蔔數量：{{ radishNumber }}</span>
      <img
        v-show="oneActive"
        class="btn-consumed btn-consumed-one"
        src="./images/consumed-one.png"
        alt=""
        @click="oneActive = true"
      />
      <img
        v-show="!oneActive"
        class="btn-consumed btn-consumed-ten"
        src="./images/consumed-ten.png"
        alt=""
        @click="oneActive = false"
      />
      <img
        v-show="!oneActive"
        class="btn-consumed btn-consumed-one"
        src="./images/Nconsumed-one.png"
        alt=""
        @click="oneActive = true"
      />
      <img
        v-show="oneActive"
        class="btn-consumed btn-consumed-ten"
        src="./images/Nconsumed-ten.png"
        alt=""
        @click="oneActive = false"
      />
      <img class="rabbit" src="./images/rabbit.png" alt="" />
      <div class="lucky-draw-box">
        <LuckyGrid
          ref="myLucky"
          :width="width"
          :height="height"
          :prizes="prizes"
          :rows="rows"
          :cols="cols"
          :blocks="blocks"
          :buttons="buttons"
          :speed="100"
          :active-style="activeStyle"
          @start="clickDrawButton"
          @end="endLuck"
        />
      </div>
      <div class="draw-count">({{ drawCount ? drawCount : 0 }}/1000)</div>
    </div>
    <el-dialog
      :visible.sync="infoDialog"
      center
      :modal-append-to-body="false"
      width="400px"
      top="30vh"
      class="candies-draw4-dialog"
    >
      <div class="draw-result-box">
        <img src="./images/bg-info.png" alt="" @click="infoDialog = false" />
        <p class="draw-name">
          恭喜！獲得<br />
          {{ drawName }}
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';

export default {
  name: 'CandiesDraw4',
  data() {
    return {
      drawName: '',
      infoDialog: false,
      oneActive: true,
      width: '839px',
      height: '839px',
      rows: 3,
      cols: 3,
      blocks: [
        {
          padding: '78px',
          imgs: [
            {
              src: require('@/activities/candies-draw4/images/draw-bg.png'),
              width: '100%',
              height: '100%'
            }
          ]
        }
      ],
      prizes: [
        {
          x: 0,
          y: 0,
          imgs: [
            {
              src: require('@/activities/candies-draw4/images/1.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw4/images/active1.png')
            }
          ]
        },
        {
          x: 1,
          y: 0,
          imgs: [
            {
              src: require('@/activities/candies-draw4/images/2.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw4/images/active2.png')
            }
          ]
        },
        {
          x: 2,
          y: 0,
          imgs: [
            {
              src: require('@/activities/candies-draw4/images/3.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw4/images/active3.png')
            }
          ]
        },
        {
          x: 2,
          y: 1,
          imgs: [
            {
              src: require('@/activities/candies-draw4/images/4.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw4/images/active4.png')
            }
          ]
        },
        {
          x: 2,
          y: 2,
          imgs: [
            {
              src: require('@/activities/candies-draw4/images/5.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw4/images/active5.png')
            }
          ]
        },
        {
          x: 1,
          y: 2,
          imgs: [
            {
              src: require('@/activities/candies-draw4/images/6.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw4/images/active6.png')
            }
          ]
        },
        {
          x: 0,
          y: 2,
          imgs: [
            {
              src: require('@/activities/candies-draw4/images/7.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw4/images/active7.png')
            }
          ]
        },
        {
          x: 0,
          y: 1,
          imgs: [
            {
              src: require('@/activities/candies-draw4/images/8.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw4/images/active8.png')
            }
          ]
        }
      ],
      activeStyle: {
        background: 'transparent'
      },
      drawResult: '', //抽獎結果
      balance: 0, //糖果餘額
      drawLoading: false,
      drawCount: 0
    };
  },
  computed: {
    ...mapGetters(['accountInfo', 'userInfo', 'token', 'refreshToken']),
    buttons() {
      return [
        {
          x: 1,
          y: 1,
          imgs: [
            {
              src: this.drawLoading
                ? require('@/activities/candies-draw4/images/active-button.png')
                : require('@/activities/candies-draw4/images/button.png'),
              width: '100%',
              height: '100%'
            }
          ]
        }
      ];
    },
    // 是否已登录状态
    isLogined() {
      return this.userInfo && (this.token || this.refreshToken);
    },
    radishNumber() {
      return parseInt(this.balance / 300);
    },
    radishCostNumber() {
      return this.oneActive ? 1 : 10;
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },
  watch: {
    uuid: {
      handler: function(newVal) {
        if (newVal) {
          this.getDrawCount();
        }
      },
      immediate: true
    }
  },
  methods: {
    showInfo() {
      this.infoDialog = true;
    },
    // 活動結束提醒
    showFinishedDialog() {
      if (true) {
        this.$confirm({
          content:
            '當前活動已結束，更多福利敬請留意nicee平臺，感謝您的支援呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: false
        }).then(() => {
          // this.$router.push({ path: '/' });
        });
      }
    },
    // 獲取詳情
    async getDetail() {
      try {
        const { data } = await this.$http.get(
          '/activity/getActivityLotteryInfo',
          {
            dictType: 'lotteryConf'
          }
        );
        this.balance = data.crystalBalance || 0;
        this.activityData = data || {};
        this.showFinishedDialog();
      } catch (error) {
        console.log(error);
      }
    },
    // 點擊抽獎按鈕
    async clickDrawButton() {
      await this.checkLogin();
      if (!this.drawLoading) {
        if (this.radishNumber >= this.radishCostNumber) {
          this.drawLoading = true;
          this.$confirm({
            content: `將花費${this.radishCostNumber}根蘿蔔開始抽獎？`,
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: true
          })
            .then(() => {
              this.getDrawInfo();
            })
            .catch(() => {
              this.drawLoading = false;
            });
        } else {
          this.$confirm({
            content: `抽獎需${this.radishCostNumber}根蘿蔔?`,
            title: '蘿蔔不足',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: true
          });
        }
      }
    },
    // 獲取抽獎結果
    async getDrawInfo() {
      // 調用抽獎組件的play方法開始遊戲
      this.$refs.myLucky.play();
      try {
        const { data } = await this.$http.get('/activity/lottery', {
          dictType: 'lotteryConf',
          count: this.radishCostNumber
        });
        if (data) {
          this.drawResult = JSON.parse(data);
          this.balance -= this.radishCostNumber * 300;
          this.$store.dispatch('app/getUserAccount');
          this.getDrawCount();
          this.startLuck();
        }
      } catch (error) {
        if (error.msg) {
          this.$message(error.msg);
        }
        this.$refs.myLucky.stop(this.luckIndex);
        this.drawLoading = false;
      }
    },

    // 開始抽獎
    startLuck() {
      const drawCode = this.oneActive
        ? this.drawResult[0].name
        : this.drawResult[this.drawResult.length - 1].name;
      switch (drawCode) {
        case 'P01':
          this.luckIndex = 0; // 繁花之戀（1天）
          break;
        case 'P02':
          this.luckIndex = 1; // 心花綻放（1天）
          break;
        case 'P03':
          this.luckIndex = 2; // 水晶寵愛（1天）
          break;
        case 'P05':
          this.luckIndex = 3; // 待君傾（1天）
          break;
        case 'P08':
          this.luckIndex = 4; // 百變兔兔（永久）
          break;
        case 'P07':
          this.luckIndex = 5; // 百變兔兔（1天）
          break;
        case 'P06':
          this.luckIndex = 6; // 動人聲（1天）
          break;
        case 'P04':
          this.luckIndex = 7; // 天使寵愛（1天）
          break;
        default:
          break;
      }
      this.startCallback();
    },

    // 點選抽獎按鈕會觸發start回調
    startCallback() {
      // 類比調用接口異步抽獎
      setTimeout(() => {
        // 調用stop停止旋轉並傳遞中獎索引
        this.$refs.myLucky.stop(this.luckIndex);
      }, 1000);
    },
    // 抽獎結束
    endLuck() {
      if (this.drawLoading) {
        this.drawLoading = false;
        let drawName = '';
        this.drawResult.forEach(item => {
          switch (item.name) {
            case 'P08':
              drawName = `${drawName}百變兔兔（永久）*${1 * item.count}、`;
              break;
            case 'P03':
              drawName = `${drawName}水晶寵愛（1天）*${1 * item.count}、`;
              break;
            case 'P01':
              drawName = `${drawName}繁花之戀（1天）*${1 * item.count}、`;
              break;
            case 'P07':
              drawName = `${drawName}百變兔兔（1天）*${1 * item.count}、`;
              break;
            case 'P05':
              drawName = `${drawName}待君傾（1天）*${1 * item.count}、`;
              break;
            case 'P04':
              drawName = `${drawName}天使寵愛（1天)*${1 * item.count}、`;
              break;
            case 'P02':
              drawName = `${drawName}心花綻放（1天）*${1 * item.count}、`;
              break;
            case 'P06':
              drawName = `${drawName}動人聲（1天）*${1 * item.count}、`;
              break;
            default:
              break;
          }
        });
        // }
        this.drawName = drawName.slice(0, -1);
        this.showInfo();
      }
    },
    // 检查登录
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    async getDrawCount() {
      const { schedule } = await this.$http.get(
        `https://devops.nicee.app/api/mengtu/${this.uuid}`
      );
      this.drawCount = schedule || 0;
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.candies {
  width: 100%;
  background-color: #c894ff;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg-img {
      width: 100%;
    }
    .balance {
      position: absolute;
      color: #fff;
      top: 987.83px;
      left: 140.69px;
      font-size: 28.99px;
      font-weight: 600;
      width: 478.01px;
      height: 56.75px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lucky-draw-box {
      text-align: left;
      display: block;
      width: 839px;
      position: absolute;
      top: 1167px;
      left: 70px;
    }
    .avatar {
      position: absolute;
      top: 474.69px;
      left: 153.96px;
      width: 198px;
      height: 198px;
    }
    .btn-consumed {
      width: 197.42px;
      height: 76.36px;
      position: absolute;
      right: 117px;
    }
    .btn-consumed-one {
      top: 923px;
    }
    .btn-consumed-ten {
      top: 1047px;
    }
    .rabbit {
      position: absolute;
      top: 1951px;
      left: 181px;
      z-index: 2;
      width: 605px;
    }
  }
  .draw-result-box {
    position: relative;
    .draw-name {
      position: absolute;
      top: 54%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 310px;
      line-height: 1.2;
      max-height: 198px;
      overflow: hidden;
      font-size: 16px;
      color: black;
      text-align: center;
      font-weight: bold;
    }
    img {
      width: 100%;
    }
  }
  .draw-count {
    position: absolute;
    top: 2229px;
    left: 644px;
    font-size: 34px;
    font-weight: bold;
  }
}
</style>
<style lang="scss">
.dialog-center {
  .van-dialog__message,
  .van-dialog__header {
    text-align: center;
  }
}
.candies-draw4-dialog {
  .el-dialog {
    background-color: transparent;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    display: flex;
    flex-direction: column;
  }
}
</style>
